import { styledWithInvalidProps } from "@components/Styled/StyledWithInvalidProps";
import React from "react";
import tw, { styled } from "twin.macro";
import { ImageZoomOutputProps, withImageZoom } from "./withImageZoom";

const Container = tw.div`
  relative w-full h-full overflow-hidden
`;

const Image = styledWithInvalidProps("img")(
  ({ width, height }: Partial<ImageZoomOutputProps>) => [
    tw`absolute overflow-hidden transition-opacity transition-transform ease-linear origin-center max-w-none duration-fast z-100 bg-white`,
    `width: ${width}px`,
    `height: ${height}px`,
  ],
);

const Zoom = styled.div`
  ${tw`absolute w-full h-full`}
  & > img {
    ${tw`transition-opacity transition-transform ease-linear opacity-0 transform-gpu duration-fast`}
  }
  &:hover {
    cursor: crosshair;
    & > img {
      ${tw`opacity-100`}
    }
  }
`;

export const ImageZoom = withImageZoom(
  ({
    canZoom,
    className,
    children,
    src,
    width,
    height,
    x,
    y,
    onMouseMove,
  }: ImageZoomOutputProps) => {
    return (
      <Container className={className} onMouseMove={onMouseMove}>
        {canZoom && (
          <Zoom className={className}>
            <Image
              style={{ transform: `translate(-${x}%, -${y}%)` }}
              src={src}
              width={width}
              height={height}
              aria-hidden="true"
            />
          </Zoom>
        )}
        {children}
      </Container>
    );
  },
);
